// Typelizer digest f482a9f1cd36509ce6c559febb932ba0
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** PATCH /c/:company_id/bank_connections/:bank_connection_id/institution_selection */
  update: (
    params: { bankConnectionId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/bank_connections/:bank_connection_id/institution_selection', params, options),
    method: 'patch',
  }),
}
